export default __webpack_public_path__ + "static/media/ColorCheckIcon.4ff0bfa8.svg";